import { render, staticRenderFns } from "./ViewProductsUnderwriting.vue?vue&type=template&id=f560efee&"
import script from "./ViewProductsUnderwriting.vue?vue&type=script&lang=js&"
export * from "./ViewProductsUnderwriting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports